import { useNavigate, useParams } from "react-router";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

type Success = {
	canRender: true;
	hotelID: string;
};

type Failure = {
	canRender: false;
};

type ReturnType = Success | Failure;

export const useConfirmParams = (): ReturnType => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.INVOICE_SYSTEM.SETTINGS>>();

	const navigate = useNavigate();

	let canRender = true;

	/**
	 *
	 * @todo hotelID ブランク時の振る舞いを設計
	 *
	 */
	if (!hotelID) {
		canRender = false;
		notifyUserEventInfo({
			title: "無効なURLです",
			description: "",
		});
		navigate(PATHS.TOP);

		return {
			canRender,
		};
	}

	return {
		canRender,
		hotelID,
	};
};
